<script>
import TwButton from '@/components/generic/tw-button.vue'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'

export default {
  name: 'FundraiserShareOverEmail',
  components: { TwValidationErrors, TwInput, TwButton },
  props: {
    fundraiser: {
      type: Object,
      required: true
    }
  },
emits: ['email-sent'],
  data() {
    return {
      DialogVisible: false,
      Loading: false,
      ValidationErrorMessage: null,
      DestinationEmails: null,
    }
  },
  methods: {
    async sendOverEmail() {
      this.ValidationErrorMessage = null
      this.Loading = true
      try {
        const response = await axios.post(`/api/v1/fundraiser-public/${this.fundraiser.id}/share-over-email`, {
          emails: this.DestinationEmails,
        })
        this.$emit('email-sent', response.data)
        this.$notify('Email sent!')
        this.DialogVisible = false
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.ValidationErrorMessage = error.response.data
        } else {
          this.ValidationErrorMessage = 'An error occurred while sending the email.'
        }
      } finally {
        this.Loading = false
      }
    }
  }
}
</script>

<template>
  <div>
    <tw-button variant="secondary" block class="mb-2" @click="DialogVisible = !DialogVisible">
      <icon icon="envelope" />  Share Via Email
    </tw-button>
    <div v-if="DialogVisible" class="mt-4">
      <tw-input v-model="DestinationEmails" class="mb-4" label="Emails (comma separated)" />
      <tw-validation-errors :validation-result-error="ValidationErrorMessage" />
      <div class="flex justify-center">
        <tw-button variant="primary" :loading="Loading" @click="sendOverEmail">
          Send
        </tw-button>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
